import React, { Component } from 'react';
import firebase from '../../firestore';
import { USER_NAME, MAX_LEADERS, LEADERS_CACHE_TIMEOUT } from '../const';
import MessageBox from '../../HOME/COMPONENTS/MessageBox';
import { Offline, Online } from 'react-detect-offline';
import { hideLeaderboards, delay, dbget, dbset, canUseLocalStorage } from '../utils';
import { getAppInfo } from '../info';
import _ from 'lodash';
import { set } from 'idb-keyval';

class LeaderBase extends Component {
  state = {
    users: [],
    // score: this.props.stats ? this.props.stats.score : 0,
    plays: this.props.stats ? this.props.stats.plays : 0,
    name: '',
  };

  init = callback => {
    const doInit = () => {
      dbget(USER_NAME, name => this.setState({ name: name || '', savedName: name || '' }));

      const db = firebase.firestore();
      db.settings({ timestampsInSnapshots: true });

      this.leaders = db
        .collection('leaderboards')
        .doc(getAppInfo(this.props.app).name)
        .collection('leaders');

      callback();
    };

    if (this.props.uid) {
      doInit();
      return;
    }

    firebase
      .auth()
      .signInAnonymously()
      .then(value => {
        this.props.setUserId(value.user.uid);
        doInit();
      })
      .catch(function(error) {
        console.log(error.code);
        console.log(error.message);
      });
  };

  createCache(time, users, skill, size) {
    if (!canUseLocalStorage) {
      return null;
    }

    skill = skill || this.state.skill;
    size = size || this.state.size;

    return set(this.cacheKey(skill, size), { time, users });
  }

  getLeaders() {
    const query = this.getQuery();

    query
      .get()
      .then(qs => {
        let users = [];

        qs.forEach(function(doc) {
          users.push({ key: doc.id, data: doc.data() });
        });

        if (!users.length) {
          // we may be offline, try cache without stale check
          this.getCachedLeaders();
          return;
        }

        if (canUseLocalStorage) {
          const time = _.now();
          this.createCache(time, users).then(() => this.getCachedLeaders());
        } else {
          users = _.take(_.orderBy(users, ['data.score', 'data.plays'], ['desc', 'desc']), MAX_LEADERS);
          this.setState({ users }, this.updateRanks);
        }
      })
      .catch(function(error) {
        console.log('Error getting documents: ', error);
      });
  }

  getCachedLeaders(staleCheck) {
    dbget(this.cacheKey(), cob => {
      if (canUseLocalStorage && cob && cob.time && (!staleCheck || _.now() - cob.time < LEADERS_CACHE_TIMEOUT)) {
        const users = _.take(_.orderBy(cob.users, ['data.score', 'data.plays'], ['desc', 'desc']), MAX_LEADERS);
        this.setState({ cacheTime: cob.time, users }, this.updateRanks);
      } else if (staleCheck) {
        // no or stale cache, try server
        this.getLeaders();
      } else {
        // we tried both cache and server, there's no data
        this.setState({ cacheTime: undefined, users: [] }, this.updateRanks);
      }
    });
  }

  updateRanks() {
    const { score, plays, users } = this.state;
    const key = this.userKey();
    const index = _.findIndex(users, u => u.key === key);
    const oldRank = 1 + index;
    const oldScore = index < 0 ? 0 : users[index].data.score;
    const oldPlays = index < 0 ? 0 : users[index].data.plays;

    let newRank = 0;

    if (score > 0) {
      const otherUsers = _.reject(users, u => u.key === key);

      for (var i = 0; i < otherUsers.length; i++) {
        const data = otherUsers[i].data;

        if (data.score < score) {
          break;
        }

        if (data.score > score) {
          continue;
        }

        if (data.plays < plays) {
          break;
        }
      }

      newRank = i < MAX_LEADERS ? i + 1 : 0;
    }

    this.setState({ oldRank, oldScore, oldPlays, newRank });
  }

  handleNameChange = e => {
    this.setState({ name: e.target.value });
  };

  canSubmit = () => {
    return this.props.uid && this.state.newRank && this.state.name && this.state.name.trim();
  };

  handleClickSubmit = e => {
    if (!this.canSubmit()) {
      return;
    }

    const name = this.state.name.trim();
    const { savedName, score, oldScore, plays, oldPlays } = this.state;

    if (name === savedName && score === oldScore && plays <= oldPlays) {
      return;
    }

    dbset(USER_NAME, name);

    if (score < oldScore) {
      this.setState({ lowerScore: true });
    } else {
      this.doSubmit();
    }
  };

  handleConfirmSubmit = yes => {
    delay(() => this.setState({ lowerScore: false }));

    if (yes) {
      this.doSubmit();
    }
  };

  doSubmit() {
    const key = this.userKey();
    const data = this.dataToSubmit();

    this.leaders.doc(key).set(data);

    const { users } = this.state;
    const user = _.find(users, u => u.key === key);

    if (user) {
      user.data = data;
    } else {
      users.push({ key, data });
    }

    this.createCache(this.state.cacheTime || _.now(), users).then(() => this.getCachedLeaders());
  }

  renderClickableScreen = () => (
    <div style={{ gridArea: '1/1', width: '100%', height: '100%' }} onClick={() => hideLeaderboards(this.props.showLeaderboards)} />
  );

  renderCommon = (rankColor, submitColor, scoreAlias = 'Score') => {
    const { plays, name, score, users, oldRank, newRank } = this.state;
    const submitClasses = `leaders-submit${this.canSubmit() ? '' : ' leaders-submit-disabled'}`;

    return (
      <>
        {this.state.lowerScore ? (
          <div style={{ gridArea: '2/1', alignSelf: 'end' }}>
            <MessageBox
              message={`Submit lower ${scoreAlias === 'Grade' ? 'grade' : 'score'}?`}
              yesNo
              width="360px"
              onReply={this.handleConfirmSubmit}
            />
          </div>
        ) : null}
        <Online>
          <div className="leaders-input-area">
            <div style={{ gridArea: '1/1' }}>Current rank</div>
            <span style={{ gridArea: '1/2', color: rankColor }}>{oldRank || 'N/A'}</span>
            <div style={{ gridArea: '1/3' }}>{scoreAlias}</div>
            <span style={{ gridArea: '1/4', color: rankColor }}>{score}</span>
            <div style={{ gridArea: '3/1' }}>New rank</div>
            <span style={{ gridArea: '3/2', color: rankColor }}>{newRank || (users.length < MAX_LEADERS ? 'N/A' : `below ${MAX_LEADERS}`)}</span>
            <div style={{ gridArea: '3/3' }}>Plays</div>
            <span style={{ gridArea: '3/4', color: rankColor }}>{plays}</span>
            <input type="text" placeholder="Your name" className="leaders-input" value={name} onChange={this.handleNameChange} />
            <div className={submitClasses} style={{ background: submitColor }} onClick={this.handleClickSubmit}>
              SUBMIT
            </div>
            <div className="leaders-footnote">
              <div>• your previous submission will be replaced</div>
              <div>• entries may be removed after one month</div>
            </div>
            {this.renderNavigation()}
          </div>
        </Online>
        <Offline>
          <div className="leaders-input-area leaders-offline-message" style={{ color: rankColor }}>
            {`It looks like you are not connected to the internet at the moment. Please come back later to submit your
            results.`}
            {this.renderNavigation()}
          </div>
        </Offline>
      </>
    );
  };
}

export default LeaderBase;
